export const educationTranslations = {
  es: {
    section_title: 'Educación',
    continuing_education_title: 'Formación continua online',
    continuing_education: [
      {
        title: 'Principios SOLID y Clean Code',
        url: 'https://www.udemy.com/course/solid-clean/',
        author: 'Fernando Herrera'
      },
      {
        title: 'React: De cero a experto ( Hooks y MERN )',
        url: 'https://www.udemy.com/course/react-cero-experto/',
        author: 'Fernando Herrera'
      },
      {
        title: 'React - Guía definitiva: hooks router redux next +Proyectos',
        url: 'https://www.udemy.com/course/react-guia-definitiva-hooks-router-redux-next-proyectos/',
        author: 'Nicolás Schurmann'
      },
      {
        title: 'Master en APIs RESTful con NodeJS: Crea 3 backends completos',
        url: 'https://www.udemy.com/course/master-en-apis-restful-con-nodejs-crea-3-backends-completos/',
        author: 'Víctor Robles'
      },
      {
        title: 'Node: De cero a experto',
        url: 'https://www.udemy.com/course/node-de-cero-a-experto/',
        author: 'Fernando Herrera'
      },
      {
        title: 'Master en webs Full Stack: Angular, Node, Laravel, Symfony',
        url: 'https://www.udemy.com/course/master-en-desarrollo-web-full-stack-angular-node-laravel-symfony/',
        author: 'Víctor Robles'
      },
      {
        title: 'Tiempo real y Laravel: Múltiples apps realtime con Laravel',
        url: 'https://www.udemy.com/course/realtime-y-laravel-crea-multiples-aplicaciones-tiempo-real-con-laravel/',
        author: 'JuanD MeGon'
      }
    ],
    barcelona_activa: {
      title: 'Backend con Node.js.',
      school: 'IT Academy - Barcelona Activa',
      description: 'Javascript, Node.js, Express, Patterns, APIs, Bases de datos, git/Github.',
      period: '2021 (3 meses)',
    },
    ioc: {
      title: 'Grado Superior en Desarrollo de Aplicaciones Web',
      school: 'Institut Obert de Catalunya (IOC)',
      description: 'Prácticas en la empresa Gestinet.',
      period: '2019 - 2021',
    },
    upc_school: {
      title: 'Curso Desarrollo de Aplicaciones Web',
      school: 'UPC School (Universitat Politècnica de Catalunya)',
      description: 'Html, CSS, Javascript, PHP, SQL. Prácticas en la empresa Clicko.',
      period: '2019 (6 meses)',
    }
  },
};
